<template>
    <div class="detail__location--box ">
        <h1 class="detail__title-preview u__padding--title">Datos del inmueble</h1>
        <div class="detail__content">
            <p>Ubicación: <span>{{selected.name}}</span></p>
            <p>Estatus: <b :class="statusColor">{{selected.statusText}}</b></p>
            <p>Tipo: <span>{{selected.type}}</span></p>
            <p v-if="selected.m2t">M² de terreno: <span>{{selected.m2t}}</span></p>
            <p v-if="selected.m2c">M² de construcción: <span>{{selected.m2c}}</span></p>
            <p v-if="totalMeters">Metros totales: <span>{{selected.totalMeters2}}</span></p>
            <p>Precio: <span>${{formatValue(selected.value)}}</span></p>
            <p v-if="typeImage">Monto Enganche: <span>${{formatValue(enganche)}}</span></p>
            
        </div>
    
    </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
    name: "DetailLocation",
    props: ["typeImage","totalMeters"],
    data() {
        return {
            amountEnganche: ""
        }
    },
    computed: {
        ...mapGetters({
            selected: 'getStatusA',
        }),
        statusColor() {
            if (this.selected.status == 1 || (this.selected.status == 2)) {
                return 'disponible';
            } else {
                if (this.selected.status == 3) {
                    return 'reservado';
                } else if (this.selected.status == 4) {
                    return 'bloqueado';
                }
            }
            return 'vendido';
        },
        enganche() {
            return  this.selected.value * 0.20;
        },
    },
    methods: {
        formatValue(value) {
            let val = (value / 1).toFixed(2).replace(',', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        montoEnganche() {
            this.amountEnganche = this.selected.value * 0.20;
        },
    },
    mounted() {
        this.montoEnganche()
    }

}
</script>
<style>
.detail__title-preview{
    font-size: 2rem;
    font-weight: 900;
}
</style>